import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { PrivateRoute } from './components/private-route/private-route.comp';
import { Login } from './pages/login/login.page';
import { UsersList } from './pages/users-list/users-list.page';
import { UserDetails } from './pages/user-details/user-details.page';
import { Layout } from './components/layout/layout.comp';
import { Logout } from './pages/logout/logout.page';
import { TenantDetails } from './pages/tenant-details/tenant-details.page';
import { TenantsList } from './pages/tenants-list/tenants-list.page';
import { RolesList } from './pages/roles-list/roles-list.page';
import { PermissionsList } from './pages/permissions-list/permissions-list.page';
import { CarrierList } from './pages/carrier-list/carrier-list.page';
import { CarrierDetails } from './pages/carrier-details/carrier-details.page';
import { MapperList } from './pages/mappers-list/mappers-list.page';
import { AddMapper } from './pages/add-edit-mapper/add-edit-mapper.page';
import { Inbox } from './pages/inbox/inbox.page';
import { ReportConfigsList } from './pages/report-config-list/report-config-list.page';
import { StatesList } from './pages/states-list/states-list.page';
import { StateDetails } from './pages/state-details/state-details.page';
import { PolicyDetails } from './pages/policy-details/policy-details.page';
import { AdminActions } from './pages/admin-actions/admin-actions.page';
import { OrganizationsList } from './pages/organizations-list/organizations-list.page';
import { OrganizationDetails } from './pages/organization-details/organization-details.page';

export function App() {
  return (
    <>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="*" element={<Navigate to="/" replace />} />
            <Route path="/" element={<PrivateRoute Component={Inbox} />} />
            <Route path="/login" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/mappers" element={<PrivateRoute Component={MapperList} />} />
            <Route path="/inbox" element={<PrivateRoute Component={Inbox} />} />
            <Route path="/carriers" element={<PrivateRoute Component={CarrierList} />} />
            <Route path="/carriers/:carrierId" element={<PrivateRoute Component={CarrierDetails} />} />
            <Route path="/carriers/:carrierId/policies/:policyId" element={<PrivateRoute Component={PolicyDetails} />} />
            <Route path="/users" element={<PrivateRoute Component={UsersList} />} />
            <Route path="/roles" element={<PrivateRoute Component={RolesList} />} />
            <Route path="/admin" element={<PrivateRoute Component={AdminActions} />} />
            <Route path="/permissions" element={<PrivateRoute Component={PermissionsList} />} />
            <Route path="/users/:userId" element={<PrivateRoute Component={UserDetails} />} />
            <Route path="/tenants/" element={<PrivateRoute Component={TenantsList} />} />
            <Route path="/tenants/:tenantId" element={<PrivateRoute Component={TenantDetails} />} />
            <Route path="/organizations/" element={<PrivateRoute Component={OrganizationsList} />} />
            <Route path="/organizations/:organizationId" element={<PrivateRoute Component={OrganizationDetails} />} />
            <Route path="/mappers/add" element={<PrivateRoute Component={AddMapper} />} />
            <Route path="/mappers/edit/:mapperId?" element={<PrivateRoute Component={AddMapper} />} />
            <Route path="/report-configs" element={<PrivateRoute Component={ReportConfigsList} />} />
            <Route path="/states" element={<PrivateRoute Component={StatesList} />} />
            <Route path="/states/:stateId" element={<PrivateRoute Component={StateDetails} />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </>
  );
}
